import SpinnerSrc from '../../spinner.webp';

export const Spinner = () => {
  return <div style={{animation: '3s linear spin infinite'}}>
    <img alt="spinner" src={SpinnerSrc} />
  </div>
}
